import React from "react";
import { NotificationProps } from "./CommonTypes";
import { ErrorBoundary } from "react-error-boundary";

const Notification: React.FC<NotificationProps> = ({
  title,
  description = "",
  timeSeen,
  message,
  host,
  score,
  additionalFields = {},
  usage,
  onClick,
}) => {
  return (
    <ErrorBoundary
      fallback={<div>Something went wrong!</div>}
      onError={(err) => console.log(err)}
    >
      {/* Single Notification */}
      <div
        style={{ cursor: onClick ? "pointer" : "default" }}
        className="p-4 text-xs bg-primary-background relative rounded-md leading-4"
        onClick={onClick}
      >
        <div className="grid grid-cols-12">
          <div className="col-span-11">
            <div className="text-sm font-bold mb-2 border-b flex gap-x-2">
              {title}
            </div>
          </div>
        </div>
        {usage && (
          <div>
            <span className="font-bold text-primary">Usage: </span>
            <span>
              {usage}
              <span className="ml-1">%</span>
            </span>
          </div>
        )}
        {description != "" && (
          <div>
            <span className="font-bold text-primary">Description: </span>
            <span className="break-all">
              {typeof description == "string"
                ? description
                : JSON.stringify(description)}
            </span>
          </div>
        )}
        {host && host.trim() != "" && (
          <div>
            <span className="font-bold text-primary">Host: </span>
            <span>{host}</span>
          </div>
        )}
        {score && score.toString().trim() != "" && (
          <div>
            <span className="font-bold text-primary">Score: </span>
            <span>{score}</span>
          </div>
        )}
        <div>
          <span className="font-bold text-primary">Time Seen: </span>
          <span>{timeSeen}</span>
        </div>
        {message?.trim() != "" && (
          <div>
            <span className="font-bold text-primary">Message: </span>
            <span>
              {typeof message == "string" ? message : JSON.stringify(message)}
            </span>
          </div>
        )}
        {Object.keys(additionalFields).map((key, index) => {
          if (key.toLowerCase() != "message") {
            return (
              <div key={index}>
                <span className="font-bold text-primary">{key}: </span>
                <span>
                  {typeof additionalFields[key] == "string"
                    ? additionalFields[key]
                    : JSON.stringify(additionalFields[key])}
                </span>
              </div>
            );
          }
        })}
      </div>
    </ErrorBoundary>
  );
};

export default Notification;
